// Public Careers API helpers — separate token storage from the Hive JWT.
const API = process.env.REACT_APP_API_URL;
const TOKEN_KEY = 'careers.applicant.token';

export const applicantToken = {
  get()  { return localStorage.getItem(TOKEN_KEY) || ''; },
  set(t) { localStorage.setItem(TOKEN_KEY, t); },
  clear(){ localStorage.removeItem(TOKEN_KEY); },
};

async function request(method, url, body, auth = false) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const t = applicantToken.get();
    if (t) headers['x-applicant-token'] = t;
  }
  const res = await fetch(`${API}${url}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
}

export const careerApi = {
  jobs:            () => request('GET', '/public/careers/jobs'),
  jobsFiltered:    (params) => request('GET', `/public/careers/jobs?${new URLSearchParams(params).toString()}`),
  jobDetail:       (req_no) => request('GET', `/public/careers/jobs/${req_no}`),
  signup:          (body) => request('POST', '/public/careers/auth/signup', body),
  verifyEmail:     (token) => request('GET', `/public/careers/auth/verify-email?token=${encodeURIComponent(token)}`),
  login:           (body) => request('POST', '/public/careers/auth/login', body),
  forgotPassword:  (body) => request('POST', '/public/careers/auth/forgot-password', body),
  resetPassword:   (body) => request('POST', '/public/careers/auth/reset-password', body),
  me:              () => request('GET', '/public/careers/me', null, true),
  apply:           (body) => request('POST', '/public/careers/apply', body, true),
  applyPublic:     (body) => request('POST', '/public/careers/apply-public', body, false),
  myApplications:  () => request('GET', '/public/careers/my-applications', null, true),
};
